import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BrandMark } from "@/components/landing/primitives";

function LegalShell({ title, updated, children }) {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="grain min-h-screen bg-[#09090b] text-zinc-100">
      <header className="glass sticky top-0 z-20 border-b border-white/5">
        <div className="max-w-3xl mx-auto px-5 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="legal-home">
            <BrandMark size={20} /><span className="font-display text-lg font-bold">DocLove</span>
          </Link>
          <Link to="/" className="flex items-center gap-1 text-sm text-zinc-400 hover:text-white transition-colors">
            <ArrowLeft size={15} /> Accueil
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-12">
        <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tight">{title}</h1>
        {updated && <p className="text-xs text-zinc-500 mt-2">Dernière mise à jour : {updated}</p>}
        <div className="mt-8 space-y-6 text-sm text-zinc-400 leading-relaxed [&_h2]:text-white [&_h2]:font-bold [&_h2]:text-base [&_h2]:mt-8">
          {children}
        </div>
      </main>
    </div>
  );
}

export function MentionsLegales() {
  return (
    <LegalShell title="Mentions légales" updated="juin 2026">
      <p><em>DocLove SAS · À compléter.</em></p>
      <div><h2>Éditeur</h2><p>DocLove SAS — informations société à compléter (SIREN, capital, siège social).</p></div>
      <div><h2>Directeur de la publication</h2><p>À compléter.</p></div>
      <div><h2>Hébergeur</h2><p>OVH SAS — 2 rue Kellermann, 59100 Roubaix, France.</p></div>
      <div><h2>Contact</h2><p>hello@doclove.app</p></div>
    </LegalShell>
  );
}

export function Confidentialite() {
  return (
    <LegalShell title="Politique de confidentialité" updated="juin 2026">
      <p>Ta vie privée est au cœur de DocLove. Voici comment on traite tes données.</p>
      <div><h2>Ce qu'on collecte</h2><p>Compte (email, nom via Google), conversations que tu importes, résultats d'analyses, données d'usage (abonnement, quotas).</p></div>
      <div><h2>Pourquoi</h2><p>Fournir le service (analyses, suivi de relations), gérer ton abonnement et améliorer le produit. Tes conversations ne sont jamais vendues ni utilisées pour entraîner des modèles.</p></div>
      <div><h2>Durée de conservation</h2><p>Tes données sont conservées tant que ton compte est actif. Tu peux demander leur suppression à tout moment.</p></div>
      <div><h2>Tes droits (RGPD)</h2><p>Accès, rectification, effacement, portabilité et opposition. Écris-nous à hello@doclove.app.</p></div>
      <div><h2>Cookies & mesure d'audience</h2><p>Les cookies analytiques (Meta, TikTok, Google) ne se déclenchent qu'avec ton consentement, révocable à tout moment.</p></div>
    </LegalShell>
  );
}

export function CGU() {
  return (
    <LegalShell title="Conditions générales d'utilisation" updated="juin 2026">
      <div><h2>Objet</h2><p>DocLove est un outil d'analyse de conversations assisté par IA. Il ne remplace pas un professionnel de santé mentale.</p></div>
      <div><h2>Abonnements</h2><p>Free, Basic (9,99€/mois) et Pro (14,99€/mois). Paiement sécurisé via Stripe. Résiliable en 1 clic à tout moment.</p></div>
      <div><h2>Responsabilité</h2><p>Les analyses sont des estimations à titre indicatif. Tu restes seul décisionnaire de tes choix relationnels.</p></div>
      <div><h2>Usage acceptable</h2><p>Tu t'engages à n'importer que des conversations dont tu es partie prenante, dans le respect de la loi.</p></div>
      <div><h2>Contact</h2><p>hello@doclove.app</p></div>
    </LegalShell>
  );
}
